export const AI_APPLICATIONS_PATH_NAME = 'ai-applications';

export const AI_APPLICATION_CREATE_DRAFT_URL = 'https://draft.terra.local';

export function isAiApplicationDraftUrl(url: string): boolean {
  return url.trim() === AI_APPLICATION_CREATE_DRAFT_URL;
}
